import { useState } from 'react';
import { Box, Tab, Tabs, Paper } from '@material-ui/core';
import { useApi, discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { RebacExplorerClient } from '../../api/RebacExplorerClient';
import { ModelViewer } from './ModelViewer';
import { CheckPanel } from './CheckPanel';
import { StatusBanner } from './StatusBanner';

export function RebacExplorerContent() {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const [tab, setTab] = useState(0);

  const client = new RebacExplorerClient({ discoveryApi, fetchApi });

  return (
    <Paper elevation={0} style={{ width: '100%' }}>
      <StatusBanner client={client} />
      <Box style={{ borderBottom: '1px solid #e0e0e0', marginBottom: 16 }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Model" />
          <Tab label="Check" />
        </Tabs>
      </Box>

      {tab === 0 && <ModelViewer client={client} />}
      {tab === 1 && <CheckPanel client={client} />}
    </Paper>
  );
}
